import Variable from '../../constants/constants.json';
import { LIST_CUSTOMER_ACCESS } from '../Constants/customerAccess.constants';

const { handleExcception } = require('../../api/sentryExceptionHandler');
const { createRequest } = require('../../api/client');

export const getCustomerAccessList = (data) => async (dispatch) => {
    const options = {
        url: `${Variable.backendUrl}/customerAccess/getActiveTempUsersInfo`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        qs: data,
    };
    try {
        const data = await createRequest(options);

        dispatch({
            type: LIST_CUSTOMER_ACCESS,
            data
        });
    } catch (err) {
        handleExcception(err);
        dispatch({
            type: LIST_CUSTOMER_ACCESS,
            data: {}
        });
    }
};
